import Vuex from 'vuex';

export default new Vuex.Store({
    state: {
        pacienteId: null, // Inicialmente, el ID del paciente es nulo
        // Otros estados aquí
    },
    mutations: {
        setPacienteId(state, id) {
            state.pacienteId = id;
        },
        // Otras mutaciones aquí
    },
    // Otros módulos y configuraciones aquí
});
